export function removeSpaces(value) {
	return String(value)
		.replace(/[^0-9.,]/g, '')
		.replace(/\s+/g, '')
}
